import { useEffect, useState } from "react";
import { CircularProgress, TextField } from "@mui/material";

type FilingReportNoteCellProps = {
  value?: string | null;
  saving: boolean;
  onSave: (note: string) => Promise<void> | void;
};

export function FilingReportNoteCell({ value, saving, onSave }: FilingReportNoteCellProps) {
  const [draft, setDraft] = useState(value ?? "");

  useEffect(() => {
    setDraft(value ?? "");
  }, [value]);

  const commit = async () => {
    const next = draft.trim();
    const previous = (value ?? "").trim();
    if (next === previous) return;
    await onSave(draft);
  };

  return (
    <TextField
      size="small"
      multiline
      minRows={2}
      maxRows={6}
      fullWidth
      placeholder="Add note…"
      value={draft}
      disabled={saving}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        void commit();
      }}
      InputProps={{
        endAdornment: saving ? <CircularProgress size={14} sx={{ mr: 1 }} /> : undefined,
      }}
      sx={{
        "& .MuiInputBase-root": { fontSize: "0.8125rem", alignItems: "flex-start" },
      }}
    />
  );
}
